import { useState, useContext,  useEffect } from "react";
import api from "../../api/axios";
import { ThemeContext } from "../../context/ThemeContext";
import config from "../../config/config";
import Image from "../../components/image/Image";
import DynamicBackButton from "../../components/backbutton/BackButton";
import { useTranslation } from "react-i18next";

const ContactUs = () => {
  const { t: trans } = useTranslation();
  const theme = useContext(ThemeContext);
  const [contact, setContact] = useState(null);
  const [error, setError] = useState(null);

  // ✅ Reactively wait for i18n initialization


  useEffect(() => {
    api
      .get(`/auth/cms/contact_us`, { params: { maincompanyid: theme.id } })
      .then((res) => {
        setContact(res.data || null);
        setError(null);
      })
      .catch((err) => {
        console.error("Failed to fetch contact info:", err);
        setError(trans("contact_us_error")); // ✅ fixed here
      });
  }, [theme.id, trans]); // ✅ also fixed dependency

  return (
    <div
      className="register-container"
      style={{
        "--bg-img": theme?.background_image
          ? `url(${config.assetsBaseUrl}/${theme.background_image})`
          : `url('images/dream-house.png')`
      }}
    >
      <style>
        {`
          body {
            background-color: #f6f8fc;
          }
        `}
      </style>

      <div className="reg-cont-inner">
        <div className="reg-frm">
          <DynamicBackButton />
          <div className="register-success">
            <div className="reg-success-img">
              <img
                src={Image.contactpinlocation}
                alt={trans("contact_us_title")}
                style={{ width: "100px" }}
              />
            </div>

            <div className="reg-success-content">
              <h2>{trans("contact_us_title")}</h2>
              <p>{trans("contact_us_intro")}</p>

              {error && (
                <p className="text-red-600 mt-2 text-sm">{error}</p>
              )}

              {!error && !contact && (
                <p className="text-gray-500 text-sm mt-2">
                  {trans("contact_us_loading")}
                </p>
              )}

              {contact?.value && (
                <div
                  className="cms-content mt-3"
                  dangerouslySetInnerHTML={{ __html: contact.value }}
                />
              )}
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ContactUs;
